import React, { PropTypes } from 'react';
import { FontIcon } from 'material-ui';
import ArrowForward from 'material-ui/svg-icons/navigation/arrow-forward';
import R from 'ramda';

const ProductStatus = props => {
  const { mapping, exportResponses } = props;
  const productName = props.product_name;
  const tourplanName = props.tourplan_name;
  const groupedByPriceCodes = (() => {
    if (!exportResponses) return null;
    const gropuedByDateRange = {};
    Object.keys(exportResponses).forEach(k => {
      if (k.indexOf('Price Code') > -1 && exportResponses[k] === 200) {
        const dateRangeStr = k.split(', Price Code: ')[0];
        const priceCode = k.split(', Price Code: ')[1];
        if (gropuedByDateRange[dateRangeStr] && gropuedByDateRange[dateRangeStr].priceCodes) {
          gropuedByDateRange[dateRangeStr].priceCodes.push(priceCode);
        } else {
          gropuedByDateRange[dateRangeStr] = { priceCodes: [priceCode], status: 200 };
        }
      } else {
        gropuedByDateRange[k] = exportResponses[k];
      }
    });
    const result = {};
    Object.keys(gropuedByDateRange).forEach(k => {
      const obj = gropuedByDateRange[k];
      if (obj.status === 200) {
        if (obj.priceCodes.length) {
          result[`${k}, Price Code(s): ${obj.priceCodes.join(',')}`] = 200;
        } else result[k] = 200;
      } else {
        result[k] = obj;
      }
    });
    return result;
  })();
  return (
    <span style={{ display: 'block', margin: '5px 0' }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {
          Array.isArray(productName) ? (
            <div style={{ whiteSpace: 'pre-wrap' }}>
              {productName.join(`\n`)}
            </div>
          ) : productName
        }
        <ArrowForward style={{ fontSize: '15px', margin: '0 5px', top: '2px' }} color={"#c8c8c8"}/>
        {` ${tourplanName} (${mapping})`}
      </div>
      <div style={{ marginLeft: '12px', overflow: 'auto' }}>
      {
        groupedByPriceCodes ? Object.keys(groupedByPriceCodes).map((dateRangeAndPriceCodes, index) => {
          const ok = groupedByPriceCodes[dateRangeAndPriceCodes] === 200;
          return (
            <div key={index}>
              <FontIcon className={ok ? 'tc-icon-check' : 'tc-icon-close'} color={ok ? '#00BCD4' : '#ff4081'} style={{ fontSize: '18px', top: '2px', marginRight: '5px' }} />
              {dateRangeAndPriceCodes.indexOf('Notes') > -1
              ? dateRangeAndPriceCodes : `Date Range: ${dateRangeAndPriceCodes} `}
              { ok ? undefined : <span style={{ color: '#ff4081' }}>{groupedByPriceCodes[dateRangeAndPriceCodes]}</span> }
            </div>
          );
        }) : undefined
      }
      </div>
    </span>
  );
};

ProductStatus.propTypes = {
  product_name: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
  ]),
  tourplan_name: PropTypes.string,
  mapping: PropTypes.string,
  exportResponses: PropTypes.object,
};

module.exports = ProductStatus;



// WEBPACK FOOTER //
// ./src/app/components/integration/export/single-product-export-status.jsx